import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="relative w-full overflow-hidden border-t border-background-200/70">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20wooden%20writing%20desk%20with%20scattered%20old%20photographs%20and%20a%20flickering%20warm%20lamp%20at%20midnight%2C%20moody%20cinematic%20lighting%2C%20deep%20charcoal%20and%20amber%20tones%2C%20artistic%20still%20life%20photography&width=1600&height=700&seq=arch-cta-desk&orientation=landscape"
          alt="深夜书桌场景，用于档案库入口区域背景"
          title="深夜黑料 事件复盘档案库"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-50/85" />
      </div>

      <div className="relative mx-auto max-w-content px-4 py-16 text-center md:px-6 md:py-24">
        <p className="text-xs tracking-[0.34em] text-accent-400">ARCHIVE IS OPEN</p>
        <h2 className="mx-auto mt-5 max-w-3xl font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
          214 篇复盘，等你把漏掉的那一段补上
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
          不管是想重新理清一件旧事，还是想提交一条可查证的线索，入口都在这里。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/archive"
            className="w-full whitespace-nowrap rounded-md bg-primary-600 px-7 py-3 text-sm font-medium text-foreground-950 transition-colors duration-200 hover:bg-primary-500 sm:w-auto cursor-pointer"
          >
            进入复盘档案库
          </Link>
          <Link
            to="/contact"
            className="w-full whitespace-nowrap rounded-md border border-background-300/70 px-7 py-3 text-sm text-foreground-800 transition-colors duration-200 hover:border-accent-500 hover:text-accent-400 sm:w-auto cursor-pointer"
          >
            投稿一条线索
          </Link>
        </div>
      </div>
    </section>
  );
}